export class EditorialSection extends HTMLElement {
    connectedCallback() {

      this.infosVideos       = this.querySelectorAll('.editorial-section__video');

      this._initVideos();

    }

    /**
     * INIT VIDEO FROM IFRAME
     */
    _initVideos() {
      this.infosVideos.forEach(function(value, index) {
        value.setAttribute('src', value.getAttribute('data-src'));
      });
    }
  
}

try {
  window.customElements.define('editorial-section', EditorialSection);
} catch(e) {}